import React, { createRef } from "react";
import ProcedureBlock from "../../../../../base/basicComponents/procedureBlock";
import createSupportingFileService from "../../../../../service/supportingFile/createSupportingFileService";
import { dataStatus, fileTags, proposedChangeTags } from "../../../../publicDictionaryValues";
import UpdateSupportingFileReviseSection from "../../../../sections/supportingFileSections/updateSupportingFileReviseSection";
import ReviseNewSupportingFilePending from "../../createSupportingFileProcess/reviseNewSupportingFilePending";
import styles from "../../style/index.module.scss";

const supportingFileTableRef = createRef();
const supportingFileRef = createRef();
const reasonRef = createRef();
const noteRef = createRef();
export default class ReviseUpdateSupportingFilePending extends ReviseNewSupportingFilePending {
  /* function about click submit button in revise page if returned files don't do change */
  handleCheckFileTableHighLight = (
    supportingFileData: any,
    tableErrorList: any,
    isTableError: any
  ) => {
    let errorIndexList: any[] = [];
    let deleteList = [];
    supportingFileData.map((fileData: any, index: any) => {
      const isReviewed = fileData.data.find((file: any) => file.name === "isReviewed").value;
      const proposedChange = fileData.data.find(
        (file: any) => file.name === "proposedChange"
      ).value;
      const fileTag = fileData.data.find((file: any) => file.name === "fileName").tagValue;
      const status = fileData.data.find((file: any) => file.name === "status").value;
      if (
        !isReviewed &&
        status !== dataStatus.approval &&
        !(
          proposedChange === null ||
          (proposedChange === proposedChangeTags.new && fileTag === fileTags.deleted) ||
          (status === null && proposedChange === proposedChangeTags.new)
        )
      ) {
        errorIndexList = [];
        tableErrorList.push(supportingFileData[index]);
        errorIndexList.push(index);
        isTableError = true;
        supportingFileData[index].isError = true;
      }
    });
    if (
      tableErrorList.length === supportingFileData.length ||
      deleteList.length === supportingFileData.length
    ) {
      // @ts-ignore
      this.isTableBorderError = true;
      this.setState({
        pageState: { ...this.state.pageState, isTableBorderError: true },
      });
      isTableError = true;
    } else if (tableErrorList.length > 0 && tableErrorList.length !== supportingFileData.length) {
      // @ts-ignore
      this.isTableBorderError = false;
      this.setState({
        pageState: { ...this.state.pageState, isTableBorderError: false },
      });
      isTableError = true;
    }

    this.constrolTableScrollWhenSubmit(
      isTableError,
      supportingFileData,
      errorIndexList,
      supportingFileTableRef
    );
  };

  handleReturnTitle = () => {
    return "Revise Update Supporting Files";
  };

  handleReturnSupportingFileSection = (obj: any) => {
    const { currentRole, supportingReplaceFileRef, isTableBorderError, isDisableAll } = obj;
    return (
      <ProcedureBlock
        className={styles.approveSupportingFile}
        child={
          <UpdateSupportingFileReviseSection
            sectionProps={{ currentRole }}
            initSupportingTableData={this.props.initSupportingTableData}
            initProcedureFileTableState={this.props.initProcedureFileTableState}
            refs={{
              supportingRef: this.props.supportingRef,
              supportingFileTableRef,
              supportingFileRef,
              reasonRef,
              noteRef,
              supportingReplaceFileRef,
            }}
            data={this.props.data}
            isTableBorderError={isTableBorderError}
            handleChangeTableErrorStatus={this.handleChangeTableErrorStatus}
            setIsTableChange={this.setIsTableChange}
            cancelIsTableChange={this.cancelIsTableChange}
            _showLoading={this.props._showLoading}
            _hideLoading={this.props._hideLoading}
            updateUploadProcedureFileNum={this.props.updateUploadProcedureFileNum}
            updateSupportingFileNum={this.props.updateSupportingFileNum}
            isDisableAll={isDisableAll}
            isMount={this.props.isMount}
          />
        }
        isShowArrow={true}
        isOpen={true}
        testid="supporting-file-block-arrow"
      />
    );
  };

  /* function about click submit or save button to trigger api */
  createSupportingFileTriggerAction = () => {
    createSupportingFileService.updateSupportingFileTriggerRevisePageAction(
      // @ts-ignore
      this.para,
      this._triggerReviseNewSupportingFilePendingSuccess,
      this._triggerReviseNewSupportingFilePendingError
    );
  };
}
